
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import Group from 'vux/src/components/group/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import FormPreview from 'vux/src/components/form-preview/index.vue'

import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import XHeader from 'vux/src/components/x-header/index.vue'

import InfiniteLoading from 'vue-infinite-loading';

export default {
components: {
Tab,
TabItem,
Divider,
XButton,
Group,
FormPreview,
Flexbox,
FlexboxItem,
InfiniteLoading,
XHeader
},

props: ['orderType'],

data() {
return {
noticeStr: '',
currentUser: 0,
orderList: {
willPay: {
currentPage: 1,
total: 0,
perPage: 0,
end: 0,
list: []
},
paid: {
currentPage: 1,
total: 0,
perPage: 0,
end: 0,
list: []
},
all: {
currentPage: 1,
total: 0,
perPage: 0,
end: 0,
list: []
},
btnShowLoading: ''
}
}
},
computed: {
isShowLoadMoreBtn() {
return this.orderList[this.currentUser]['total'] >= this.orderList[this.currentUser]['currentPage'] * this.orderList[this.currentUser]['perPage']
}
},
created: function () {
document.title = '订单列表'
this.currentUser = this.orderType;
},

methods: {
refto(id) {

window.location.href = '/html/uc/orderDetail/' + id
},
infiniteHandler($state) {
const url = this.tianYiWebUrl + '/wechat/order/ajaxGetListByType';
this.btnShowLoading = true;
this.$http.get(url, {
params: {
type: this.currentUser,
page: this.orderList[this.currentUser]['currentPage']
}
}).then(r => {
let res = r.data;
if (res.code === 200) {
let vRes = res.data;
this.noticeStr = res.extra;
this.orderList[this.currentUser]['list'] = [... this.orderList[this.currentUser]['list'], ...res.data.data];
this.orderList[this.currentUser].currentPage = +res.data.current_page + 1;
if (vRes.total > vRes.per_page * vRes.current_page) {
this.orderList[this.currentUser]['perPage'] = res.data.per_page;
this.orderList[this.currentUser]['total'] = res.data.total;
this.btnShowLoading = false;
$state.loaded();
} else {
this.orderList[this.currentUser]['end'] = 1
$state.complete();
}
}
})
},
handleChange(i) {
this.currentUser = i === 0 ? 'willPay' :
(i === 1 ? 'paid' :
(i === 2 ? 'all' : ''));
console.log(`切换到${i}, 当前标识为${this.currentUser}`);

if (this.orderList[this.currentUser]['list'].length === 0) {



}




if (this.orderList[this.currentUser]['total'] === 0
|| this.orderList[this.currentUser]['end'] === 0) {
this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
}
},
getList() {
const url = this.tianYiWebUrl + '/wechat/order/ajaxGetListByType';
this.btnShowLoading = true;
this.$http.get(url, {
params: {
type: this.currentUser,
page: this.orderList[this.currentUser]['currentPage']
}
}).then(r => {
let res = r.data;
if (res.code === 200) {
this.orderList[this.currentUser]['list'] = [... this.orderList[this.currentUser]['list'], ...res.data.data];
this.orderList[this.currentUser].currentPage = +res.data.current_page + 1;
this.orderList[this.currentUser]['perPage'] = res.data.per_page;
this.orderList[this.currentUser]['total'] = res.data.total;
this.btnShowLoading = false;
}
})
},
getMore() {
this.getList()
},
cancel(id) {
let _self = this;
this.$vux.confirm.show({
title: '请确认',
content: '您是否要取消该订单',
onConfirm() {
_self.$vux.loading.show({
'text': '处理中'
});
const url = _self.tianYiWebUrl + '/wechat/order/cancel'
_self.$http.post(url, {orderId: id}).then(r => {
if (r.data.code === 200) {
_self.$vux.loading.hide();
_self.$vux.alert.show({
title: '提示',
content: r.data.message,
onHide() {
window.location.reload()
}
})
} else {
_self.$vux.loading.hide();
_self.$vux.alert.show({
title: '提示',
content: '取消订单失败'
})
}
})
},
});


}
}
}



// WEBPACK FOOTER //
// ./src/components/uc/OrderLists.vue